



















































































import Vue from 'vue';
import RoutePaths from '@/router/route_paths';
import MobileLinks from '@/components/ui/MobileLinks.vue';

export default Vue.extend({
  components: {
    'mobile-links': MobileLinks,
  },
  props: {
    hideCloseButton: Boolean,
  },
  computed: {
    userLabel(): string {
      if (!this.$store.state.user) {
        return '';
      }
      if (this.$store.state.user.isAnonymous) {
        return this.$store.state.tr.Guest;
      }
      return this.$store.state.user.email || '';
    },
  },
  methods: {
    onClose(): void {
      this.$store.commit('setMobileLinksPopup', false);
    },
    onSignIp(): void {
      this.$store.commit('setMobileLinksPopup', false);
      this.$router.push({
        path: RoutePaths.LOGIN,
        query: {
          action: 'newuser',
        },
      });
    },
  },
});
